export default {"src":"/_next/static/media/strawberries.1463c522.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};